import { useCallback } from "react";
import { useApolloClient } from "@apollo/client";
import { Select, SelectProps } from "@cofano/cck";
import { Contact } from "types/commons";
import { ContactRoleType } from "__generated__/enums";
import { GetContactsForCharterByContactRoleTypeDocument } from "__generated__/view/relations/graphql/relation.queries.generated";

const ContactSelect = ({
	relations,
	roleType,
	isDefault,
	...rest
}: Omit<SelectProps<Contact, true>, "fetchOptions" | "paginated" | "getOptionLabel"> & {
	relations: { id: number }[],
	roleType?: ContactRoleType | undefined;
	isDefault?: boolean;
}) => {

	const client = useApolloClient();

	const onFetchOptions = useCallback(async(input: string, page: number) => {
		try {
			const result = await client.query({
				query: GetContactsForCharterByContactRoleTypeDocument,
				variables: {
					search: {
						relations: relations.filter(r => !!r).map(r => r.id),
						roleType,
						isDefault,
					},
					pagination: {
						size: 10,
						page: page - 1,
					},
				},
			});

			return {
				options: (result.data.contacts.content || []) as Contact[],
				totalResults: result.data.contacts.totalElements,
			};
		} catch (response) {
			return {
				options: [],
				totalResults: 0,
			};
		}
	}, [ client, relations ]);

	const getOptionLabel = (contact: Contact): string => {
		if (contact.email != null) {
			return `${contact.name} (${contact.email})`;
		} else {
			return `${contact.name}`;
		}
	};

	return (
		<Select
			disableSearch
			multiple={true}
			fetchOptions={onFetchOptions}
			paginated
			getOptionLabel={getOptionLabel}
			{...rest} />
	);
};

export default ContactSelect;
